module.exports = __webpack_public_path__ + "img/car_00053.f7e9ba59.jpg";